module.exports = {
  // Global App actions
  FINISH_INIT_APP: 'FINISH_INIT_APP',
  START_APP_LOADING_GLOBAL: 'START_APP_LOADING_GLOBAL',
  STOP_APP_LOADING_GLOBAL: 'STOP_APP_LOADING_GLOBAL',
  // ERROR PAGE
  ERROR_PAGE_CODE: 'ERROR_PAGE_CODE',
};
